import React from 'react';
import { useTranslation } from 'react-i18next';

import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import './comparison.scss';

const comparisonRows = [
  { key: 'if_else', typicalHas: false },
  { key: 'activity_triggers', typicalHas: true },
  { key: 'chaos_mode', typicalHas: false },
  { key: 'channel_points_rewards', typicalHas: false },
  { key: 'watch_time', typicalHas: false },
  { key: 'watch_streak', typicalHas: false },
  // { key: 'giveaway_periods', typicalHas: false },
  { key: 'lurker_tracking', typicalHas: false },
  { key: 'ticket_system', typicalHas: false },
  { key: 'eligibility', typicalHas: false }
];

export const Comparison = () => {
  const { t } = useTranslation('comparison');

  return (
    <section id="why-we" className="landing__comparison">
      <h2 className="landing__section-title">{t('title')}</h2>
      <div className="landing__comparison-table">
        <div className="landing__comparison-header">
          <div className="landing__comparison-cell">
            <strong>{t('feature')}</strong>
          </div>
          <div className="landing__comparison-cell landing__comparison-cell--brand">
            <strong>{t('brand')}</strong>
          </div>
          <div className="landing__comparison-cell">
            <strong>{t('generic')}</strong>
          </div>
        </div>

        {comparisonRows.map((row) => (
          <div className="landing__comparison-row" key={row.key}>
            <div className="landing__comparison-cell">{t(`rows.${row.key}`)}</div>
            <div className="landing__comparison-cell landing__comparison-cell--brand">
              <CheckOutlined />
            </div>
            <div className="landing__comparison-cell">
              {row.typicalHas ? <CheckOutlined /> : <CloseOutlined />}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
